window.checkboxRequired = function (className) {
    document.addEventListener('DOMContentLoaded', () => {
        // Target the closest form element wrapping this group specifically
        const group = document.querySelector(`.${className}-checkbox-group`);
        if (!group) return;
        const form = group.closest('form');
        if (!form) return;

        const checkboxes = group.querySelectorAll('input[type="checkbox"]');
        const errorMessage = document.getElementById(`${className}-error-checkbox`);

        const validateCheckboxes = () => {
            const isAnyChecked = Array.from(checkboxes).some(cb => cb.checked);

            if (errorMessage) {
                errorMessage.style.display = isAnyChecked ? 'none' : 'block';
            }

            return isAnyChecked;
        };

        // Live validation toggles
        checkboxes.forEach(cb => {
            cb.addEventListener('change', validateCheckboxes);
        });

        // Intercept and hard-kill the submit event if invalid
        form.addEventListener('submit', (event) => {
            if (!validateCheckboxes()) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation(); // Prevents other JS handlers from firing submit

                if (errorMessage) {
                    errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }

                return false;
            }
        });
    });
};